// extracted by mini-css-extract-plugin
export default {"ipDisplay":"IPDisplay_ipDisplay__kAi2F","separator":"IPDisplay_separator__LbIPZ"};